import {useEffect} from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import useCcWebviewUtilsHelper from '@di-shared/features/common/useCcWebviewUtilsHelper';
import {diApi} from '@di-shared/api/di';
import {useSuspenseQueries} from '@tanstack/react-query';
import {getQueryKey} from '@shared/queryKeyMap';
import {roundToFixed} from '@di-shared/utils';

interface HomeMileageEarningNoticeKrProps {
  vin: string;
}

function HomeMileageEarningNoticeKr({vin}: HomeMileageEarningNoticeKrProps) {
  const {t} = useInferableTranslation();
  const {openAlert} = useCcWebviewUtilsHelper();
  const [notificationData, mileageHistory] = useSuspenseQueries({
    queries: [
      {
        queryKey: [getQueryKey(diApi.ecoMileageController.getNotifications), vin],
        queryFn: () => diApi.ecoMileageController.getNotifications({vin}),
        staleTime: 0,
        gcTime: 0,
      },
      {
        queryKey: [getQueryKey(diApi.ecoMileageController.getInfoMileage), vin],
        queryFn: () => diApi.ecoMileageController.getInfoMileage({vin}),
        staleTime: 0,
        gcTime: 0,
      },
    ],
  });

  const mileageAccumulationData = notificationData.data.data.find((item: any) => item.type === 'MILEAGE_ACCUMULATION');
  const updatedAt = new Date(mileageAccumulationData?.updatedAt || '');
  const infoMileagePymntInfo = mileageHistory?.data.data.rtn_data.PYMNT_INFO;
  const updatedHistory = infoMileagePymntInfo.filter((history) => new Date(history.pynmt_incntv_de) > new Date(updatedAt)) || [];
  const notificationId = mileageAccumulationData?.id;

  useEffect(() => {
    (async function () {
      if (updatedHistory.length > 0 && notificationId) {
        const updatedBalance = updatedHistory.reduce((acc, cur) => acc + cur.pynmt_incntv, 0);
        await openMileageEarningsDetailsAlert(updatedBalance);
        await diApi.ecoMileageController.updateNotification({
          vin,
          notificationId,
          requestBody: {confirmed: true},
        });
      }
    })();
  }, []);

  async function openMileageEarningsDetailsAlert(mileage: number) {
    const fixedMileage = roundToFixed(mileage / 10000, 1);
    return await openAlert({
      title: t('T30270_$mileage', {mileage: fixedMileage}),
      message: t('T30271'),
    });
  }

  return <></>;
}

export default HomeMileageEarningNoticeKr;
